// extracted by mini-css-extract-plugin
module.exports = {"faq__item":"FAQItem_faq__item__IBlAz","faq__item-description":"FAQItem_faq__item-description__1epWH","minus":"FAQItem_minus__8Xv_w"};